import attrHash from './hash';
let selected = {};

export default {
    push: function (attr) {
        selected[attr.key] = attr;
    },
    deleteAttr: function (attr) {
        delete selected[attr.key];
    },
    clear: function () {
        selected = {};
    },
    getAll: function () {
        return selected;
    },
    getByExcept: function (except) {
        var _selected = {};
        $.each(selected, function (key, attr) {
            if (key !== except) {
                _selected[key] = attr;
            }
        });
        return _selected;
    },
    getLength: function (obj) {
        obj = obj || selected;
        var len = 0;
        $.each(obj, function () {
            len++;
        });
        return len;
    },
    _copyFriends: function (attr) {
        var res = {};
        for (var name in attr.friends) {
            if (attr.friends.hasOwnProperty(name)) {
                res[name] = attr.friends[name];
            }
        }
        return res;
    },
    getSelected: function () {
        return selected;
    },
    getFriends: function (_selected) {
        var res = {};
        var count = 0;
        var that = this;
        $.each(_selected, function (key, attr) {
            if (count === 0) {
                res = that._copyFriends(attr);
            } else {
                var _res = {};
                for (var name in attr.friends) {
                    if (attr.friends.hasOwnProperty(name)) {
                        if (res[name]) {
                            _res[name] = 1;
                        }
                    }
                }
                res = _res;
            }
            count++;
        });
        return res;
    },
    enable: function (list, except, index, length) {
        var that = this,
            _selected = that.getByExcept(except),
            stocks = attrHash.stocks;

        var res = that.getSelectedKey(_selected, length);

        $.each(list, function (i, attr) {
            res[attr.index] = '\\[' + attr.id + '\\]';
            var reg = that.toRegexp(res);
            $.each(stocks, function (key, goods) {
                if (reg.test(key)) {
                    if (goods.number !== 0) {
                        attr.disable = false;
                    }
                }
            });
        });

        //			if (len === 0) {
        //				// 当只有一个规格
        //				if (length === 1) {
        //					$.each(list, function(i, attr){
        //						attr.disable = stocks['['+attr.id+']'].number === 0;
        //					});
        //				} else {
        //					$.each(list, function(i, attr){
        //						attr.disable = false;
        //					});
        //				}
        //			} else {
        //				var res = that.getSelectedKey(_selected, length);
        //				$.each(list, function(i, attr){
        //					res[attr.index] = '\\[' + attr.id + '\\]';
        //					var reg = that.toRegexp(res);
        //					$.each(stocks, function(key, goods){
        //						if (reg.test(key)) {
        //							if (goods.number !== 0) {
        //								attr.disable = false;
        //								return;
        //							}
        //						}
        //					})
        //				})
        //			}
    },
    getSelectedKey: function (hash, length) {
        var res = [];
        res.length = length;
        $.each(hash, function (i, attr) {
            res[attr.index] = '\\[' + attr.id + '\\]';
        });
        return res;
    },
    toRegexp: function (array) {
        var res = $
            .map(array, function (str) {
                if (str === undefined) {
                    return '\\[.*\\]';
                } else {
                    return str;
                }
            })
            .join('');
        return new RegExp(res);
    },
    getAttrImgs: function () {
        var imgs = {};
        $.each(selected, function (i, attrObject) {
            if (attrObject.imgs) {
                imgs.key = attrObject.value;
                imgs.imgs = attrObject.imgs;
                return false;
            }
        });
        return imgs;
    }
};



// WEBPACK FOOTER //
// ./src/js_modules/attribute/selected.js